import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { UpdateOrganizationParams } from './types';

/* eslint-disable camelcase */
const WIRE_KEYS: Record<keyof UpdateOrganizationParams, string> = {
  name: 'name',
  description: 'description',
  phone: 'phone',
  website: 'website',
  religion: 'religion',
  denomination: 'denomination',
  searchRank: 'search_rank',
  approxSize: 'approx_size',
  launchedAt: 'launched_at',
  typeId: 'type_id',
  streetAddress: 'street_address',
  city: 'city',
  state: 'state',
  zipcode: 'zipcode',
  country: 'country',
  latitude: 'latitude',
  longitude: 'longitude',
  mainImage: 'main_image',
};
/* eslint-enable camelcase */

export async function updateOrganization(organizationId: string, params: UpdateOrganizationParams) {
  const url = `/web/studio/organizations/${organizationId}`;

  const body: Record<string, unknown> = {};

  (Object.keys(params) as (keyof UpdateOrganizationParams)[]).forEach((key) => {
    if (params[key] !== undefined) body[WIRE_KEYS[key]] = params[key];
  });

  const response = await api.executePutRequest<ObjectResponse<Record<string, unknown>>>(url, body);

  return response.data;
}
